const page     = require('../../../../../components/page/page')
const itemDt   = require('./item-dt')
const treemap  = require('./chart/item-treemap-chart')

import itemPage from "./item-page.html";


/****************ELEMENTS*****************/
var HTMLwasSelected = false

//insert the page  on the body
function HTMLselect(detail) {

   HTMLwasSelected = true

   //load the page to the index
   const body = document.body
   body.insertAdjacentHTML("beforeend", itemPage)

   itemDt.start({ "dest": "item", "elem": "dt", "act": "select", "entity": "item" })
   treemap.createTreemapChart("")

}/*init*/

/****************ELEMENTS*****************/

export function start(detail) {

   if (!HTMLwasSelected) { HTMLselect(detail) }

   obj[detail.act].start(detail)
}

const obj = {

   show:          { start: (detail) => { page.start(detail)    } },
   removeReport:  { start: (detail) => { removeReport(detail)  } },

}/**/

function removeReport(detail){
   const reportPage = document.querySelector(`#${detail.pageId}`);

   if(!reportPage){return}

   reportPage.remove();
}